<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="车型名称">
              <a-input v-model.trim="queryParam.name" placeholder="请输入车号"/>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
               <!--<a @click="toggleAdvanced" style="margin-left: 8px">
                 {{ advanced ? '收起' : '展开' }}
                 <a-icon :type="advanced ? 'up' : 'down'"/>
               </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleSave()">新增</a-button>
    </div>
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x:1200 }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
    <span slot="serial" slot-scope="text, record, index">
      {{ index + 1 }}
    </span>

      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
         <a-dropdown>
          <a class="ant-dropdown-link"> 更多<a-icon type="down"/></a>
          <a-menu slot="overlay">
          <!--  <a-menu-item><a @click="handleAccredit(record)">拉黑</a></a-menu-item>-->
            <a-menu-item><a @click="handleDel(record)">删除</a></a-menu-item>
          </a-menu>
        </a-dropdown>

      </span>
    </s-table>
    <a-modal
      title="操作"
      style="top: 10px;"
      :width="800"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item
          label="车型名称"
          validateStatus="success"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="车型名称" v-model="mdl.name"
                   v-decorator="['name', { initialValue: mdl.name, rules: [{ required: true, message: '请输入车型名称'}]}]"/>
        </a-form-item>
        <a-form-item
          label="荷载重量"
          validateStatus="success"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input-number      placeholder=""  v-model="mdl.loadWeight" type="number"  :min="0"
                   v-decorator="['loadWeight', { initialValue: mdl.loadWeight, rules: [{ required: true, message: '请输入荷载重量'}]}]"/>
        </a-form-item>

        <a-form-item
          label="超限重量"
          validateStatus="success"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input-number     placeholder=""  v-model="mdl.overrunWeight" type="number"  :min="0"
                       v-decorator="['overrunWeight', { initialValue: mdl.overrunWeight, rules: [{ required: false, message: '请输入超限重量'}]}]"/>
        </a-form-item>
        <a-form-item
          label="轴型"
          validateStatus="success"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="轴型" v-model="mdl.shaftType"
                   v-decorator="['shaftType', { initialValue: mdl.shaftType, rules: [{ required: true, message: '请输入轴型'}]}]"/>
        </a-form-item>
        <a-form-item
          label="轴数"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="轴数"
                   v-decorator="['shaftNumber', { initialValue: mdl.shaftNumber, rules: [{ required: true, message: '请输入正整数'}]}]"  v-model="mdl.shaftNumber" @blur="validateNumberBlur" />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      title="黑名单"
      :width="640"
      v-model="accredit" @ok="handleAccreditOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">


        <a-form-item
          label="车号/车型/企业名/姓名"
          hasFeedback
          validateStatus="success"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="起一个名字" v-model="mdl.name" id="role_name" />
        </a-form-item>

        <a-form-item
          label="类型"
          hasFeedback
          validateStatus="warning"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-select  placeholder="请选择" v-model="mdl.type" v-decorator="['type', { initialValue: mdl.type, rules: [{ required: true, message: '请选择'}]}]">
            <a-select-option value="车辆">车辆</a-select-option>
            <a-select-option value="车型">车型</a-select-option>
            <a-select-option value="企业">企业</a-select-option>
            <a-select-option value="驾驶员">驾驶员</a-select-option>
            <a-select-option value="押运员">押运员</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="拉黑原因"
          hasFeedback
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-textarea :rows="1" v-model="mdl.remark" placeholder="..." id="describe"/>
        </a-form-item>
      </a-form>
    </a-modal>


  </a-card>
</template>
<script>
  import { STable } from '@/components'
  import { vehicleTypePage, vehicleTypeSave, vehicleTypeUpdate, vehicleTypeDelete } from '@/api/basic'
 /* import {  corpLogisticsList, getCorpSupplierList,corpCompanyList,corpBusinessList ,driverList} from '@/api/basic'*/
  import { blackListSave } from '@/api/basic'
  import { formatDate } from '@/utils/date'
  import moment from 'moment'

  export default {
    name: 'VehicleTypeList',
    components: {
      STable
    },
    data () {
      return {
        pageSizeOptionsList:['10'],
        description: '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
        visible: false,
        confirmLoading: false,
        accredit: false,
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '#',
            scopedSlots: { customRender: 'serial' },
            width: '40px',
            fixed: 'left'
          },
          {
            title: '车型名称',
            width: '120px',
            dataIndex: 'name'
          },
          {
            title: '荷载重量',
            width: '120px',
            dataIndex: 'loadWeight',
          },
          {
            title: '超限重量',
            width: '120px',
            dataIndex: 'overrunWeight',
          },
          {
            title: '轴型',
            width: '100px',
            dataIndex: 'shaftType',
          },
          {
            title: '轴数',
            width: '100px',
            dataIndex: 'shaftNumber',
          },
           {
          title: '创建人',
          dataIndex: 'createId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
          {
            title: '操作',
            width: '130px',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
             fixed: 'right'
          }
        ],

        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return vehicleTypePage(Object.assign(parameter, this.queryParam))
            .then(res => {
              return res.data
            })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },
        optionAlertShow: true
      }
    },
    created () {
      this.tableOption()
     // this.loadSelect()
    },
    methods: {
      moment,
     /* oninput(e) {
        // 通过正则过滤小数点后两位
        e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null

      },*/
      // 正整数校验事件
        validateNumberBlur(e) {
        const validateNumberReg =/^[1-9]\d*$/;
        if (e.target.value && !validateNumberReg.test(e.target.value)) {
          const arr = [{
            message: '请输入正整数!',
            field: 'shaftNumber',
          }]
          this.form.setFields({ shaftNumber: { value: e.target.value, errors: arr } })
        }
      },
      validatePhoneBlur(e) {
        const validatePhoneReg = /^1[3456789]\d{9}$/
        if (e.target.value && !validatePhoneReg.test(e.target.value)) {
          const arr = [{
            message: '您输入的手机格式不正确!',
            field: 'phone',
          }]
          this.form.setFields({ phone: { value: e.target.value, errors: arr } })
        }
      },
      // 身份证号校验事件
      validateIdCardBlur(e) {
        const validateIdCardReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        if (e.target.value && !validateIdCardReg.test(e.target.value)) {
          const arr = [{
            message: '您输入的身份证号格式不正确!',
            field: 'idcard',
          }]
          this.form.setFields({ idcard: { value: e.target.value, errors: arr } })
        }
      },
      // 验证浮点数
      validateFloatBlur(e) {
        const validateFloatReg = /^[+-]?((0|([1-9]\d*))\.\d+)?$/
        if (e.target.value && !validateFloatReg.test(e.target.value)) {
          const arr = [{
            message: '请输入数字类型!',
            field: 'shaftNumber',
          }]
          this.form.setFields({ shaftNumber: { value: e.target.value, errors: arr } })
        }
      },
      /*loadSelect () { // 从后台拉去下拉列表数据

        new Promise(resolve => {
          const data = getCorpSupplierList({ }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.corpSupplierSelect = res
        })
      },*/
      filterOption (input, option) { // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      tableOption () {
        if (!this.optionAlertShow) {
          this.options = {
            alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
            rowSelection: {
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange
            }
          }
          this.optionAlertShow = true
        } else {
          this.options = {
            alert: false,
            rowSelection: null
          }
          this.optionAlertShow = false
        }
      },
      handleEdit (record) {
        this.mdl = Object.assign({}, record)
        //每次打开弹窗之前重置下form表单
        this.form = this.$form.createForm(this)
        // 弹出框显示
        this.visible = true
      },
      handleSave () {
        this.mdl = {}
        //每次打开弹窗之前重置下form表单
        this.form = this.$form.createForm(this)
        // 弹出框显示
        this.visible = true
      },

      handleOk () {
          var shaftN=this.mdl.shaftNumber
          const validateNumberReg =/^[1-9]\d*$/;
          if (shaftN && !validateNumberReg.test(shaftN)) {
            const arr = [{
              message: '请输入正整数!',
              field: 'shaftNumber',
            }]
            this.form.setFields({ shaftNumber: { value: shaftN, errors: arr } })
            return
          }
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true
            if (this.mdl.id !== undefined) {
              vehicleTypeUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
            } else {
              vehicleTypeSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
            }
          }
        })
      },

      handleAccredit (record) {
        this.mdl = Object.assign({}, record)
        this.form = this.$form.createForm(this)
        this.accredit = true
      },

      handleAccreditOk () {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true
            blackListSave(Object.assign({}, this.mdl))
              .then(res => {
                  if(res.code =='0') {
                    this.$refs.table.refresh()
                  }
              }).catch(() => {
            }).finally(() => {
              this.confirmLoading = false
              this.accredit = false
            })
          }
        })
      },


      handleDel (record) {
        var nthis = this
        this.$confirm({
          title: '提示',
          content: '确定要删除吗?',
          onOk () {
            nthis.confirmLoading = true
            return vehicleTypeDelete(Object.assign(record, nthis.queryParam))
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            }).catch((e) => {
              console.log(e)
            }).finally(() => {
                nthis.confirmLoading = false
            })
          },
          onCancel () {
          }
        })
      },
      handleChange (value) {
        console.log('选择参数>>>' + value)
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      }
    },
  }
</script>
<style>
  input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  .number_input {
    border: 1px solid #ccc;
  }
</style>
